'use client'

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

type LifeCardProps = {
  imageUrl?: string
  title?: string
  description?: string
  link?: string
  isLoading?: boolean
}

const LifeCard: React.FC<LifeCardProps> = ({
  imageUrl = '',
  title = '',
  description = '',
  link = '',
  isLoading = false,
}) => {
  if (isLoading) {
    return (
      <div className="flex gap-4 py-2 animate-pulse">
        <div className="w-[150px] h-[90px] bg-gray-300 rounded-lg"></div>
        <div className="flex-1">
          <div className="w-2/3 h-6 bg-gray-300 rounded-md mb-2"></div>
          <div className="w-1/2 h-4 bg-gray-300 rounded-md"></div>
        </div>
      </div>
    )
  }

  return (
    <article>
      <Link href={`/${link}`} className="flex gap-4 py-2">
        <div className="relative w-[150px] h-[90px]">
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${imageUrl}`}
            alt={title}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
            className="object-cover"
            priority
            unoptimized
          />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-title font-semibold text-gray-800 hover:text-primary">
            {title}
          </h3>
          <p className="text-sm text-gray-600 mt-1 line-clamp-2">{description}</p>
        </div>
      </Link>
    </article>
  )
}

export default LifeCard
